import { useMutation, useQueryClient } from "@tanstack/react-query";
import { seriesEnroll } from "../services/quizSeriesEnrollService";

export function useSeriesEnroll() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: seriesEnroll,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["seriesQuizList"] });
      queryClient.invalidateQueries({ queryKey: ["quizSeriesList"] });
    },
  });
}
